import { LoyaltySvgIcon, type LoyaltyIconProps } from './LoyaltySvgIcon';

export const JoystickIcon = (props: LoyaltyIconProps): JSX.Element => (
    <LoyaltySvgIcon {...props}>
        <circle cx="10" cy="5.4" r="2.7" />
        <path d="M9.1 7.7h1.8v7.5H9.1z" />
        <circle cx="16.7" cy="12.1" r="1.7" />
        <path d="M15.9 12.8h1.6v2.5h-1.6z" />
        <path d="M3.5 16.6c0-.9.7-1.6 1.6-1.6h13.8c.9 0 1.6.7 1.6 1.6v2.8c0 1.1-.9 2-2 2H5.5c-1.1 0-2-.9-2-2v-2.8z" />
    </LoyaltySvgIcon>
);
